"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { breadcrumbAnatomy } from "@chakra-ui/react/anatomy"

const breadcrumb = defineSlotRecipe({
  className: "hydrologiq-breadcrumb",
  slots: breadcrumbAnatomy.keys(),

  variants: {
    variant: {
      hydrologiq: {
        root: {
          base: {
            width: "100%",
          },
          md: {
            width: "auto",
          },
        },
        link: {
          _hover: { cursor: "pointer" },
        },
        item: {
          color: "primary",
          fontSize: "18px",
          _hover: { color: "#0bc5ea", cursor: "pointer", borderColor: "#0bc5ea" },
          py: "5px",
          borderBottom: "3px solid",
          borderColor: "#cbcbcb",
          "&.selected": {
            color: "#0bc5ea",
            borderColor: "#0bc5ea",
            fontWeight: "600",
          },
          "&.menu-item": {
            borderColor: "#444444",
          },
          "&.selected-secondary": {
            borderColor: "#a170d9",
            fontWeight: "600",
          },
          base: {
            width: "43%",
          },
          md: {
            width: "auto",
          },
        },
        list: {
          base: {
            flexDirection: "row",
            alignItems: "flex-start",
            flexWrap: "wrap",
          },
          md: {
            flexDirection: "row",
            alignItems: "center",
          },
        },
        separator: {
          base: {
            display: "none",
            "&.sub-nav-separator": {
              display: "block",
            },
          },
          md: {
            display: "block",
          },
        },
      },
      plain: {
        root: {
          base: {
            width: "100%",
          },
          md: {
            width: "auto",
          },
        },
        link: {
          color: "gray.600",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "1.2",
          textDecoration: "underline",
          textDecorationColor: "#cbcbcb",
          textDecorationThickness: "1.5px",
          textUnderlineOffset: "3px",
          transition: "color 0.15s ease, text-decoration-color 0.15s ease",
          _hover: { color: "#0bc5ea", textDecorationColor: "#0bc5ea", cursor: "pointer" },
        },
        item: {
          color: "gray.600",
          fontSize: "14px",
          fontWeight: "500",
          _hover: { color: "gray.900", cursor: "pointer" },
          py: "2px",
        },
        list: {
          base: {
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
          },
          md: {
            flexDirection: "row",
            alignItems: "center",
          },
        },
        separator: {
          color: "gray.400",
          fontSize: "10px",
          display: "flex",
          alignItems: "center",
        },
      },
    },
  },
})

export default breadcrumb
